import React, { useMemo } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import EmptyBanner from 'redesign/components/molecules/empty-page-banner'
import { EMPTY_BANNER_SIZE } from 'redesign/components/molecules/empty-page-banner/constants'
import { EMPTY_PAGE_DETAILS } from './constants'
import { EmptyPageContainer } from './styles'
import type { EmptyPageProps } from './types'

const EmptyPage: React.FC<EmptyPageProps> = ({
  variant,
  isCentered,
  isAbsolute = true,
  size = EMPTY_BANNER_SIZE.normal,
}) => {
  const theme = useTheme()
  const { t } = useFavurTranslation()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const { illustration, translationKey } = useMemo(
    () => EMPTY_PAGE_DETAILS[variant] ?? EMPTY_PAGE_DETAILS.default,
    [variant],
  )

  return (
    <EmptyPageContainer isCentered={isCentered} isAbsolute={isAbsolute}>
      <EmptyBanner illustration={illustration} text={t(translationKey)} isSmallScreen={isSmallScreen} size={size} />
    </EmptyPageContainer>
  )
}

export default EmptyPage
